import { useRef, ChangeEvent } from 'react'
import { Button, UploadFileProps } from '@wellesley/ui'

type LocalFilesTabProps = {
  onUpload: (files: UploadFileProps[]) => void
}

export const LocalFilesTab = ({ onUpload }: LocalFilesTabProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target
    if (!files) return

    const uploadFiles = Array.from(files).map((file) => ({
      file,
      objectUrl: URL.createObjectURL(file),
    }))

    onUpload(uploadFiles)

    event.target.value = ''
  }

  const handleUploadButtonClick = () => {
    fileInputRef.current?.click()
  }

  return (
    <div className="space-y-s">
      <div className="text-sm text-gray-600">
        Upload files from your computer
      </div>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/*,video/*"
        onChange={handleFileInputChange}
        className="hidden"
      />
      <Button onClick={handleUploadButtonClick} className="w-full">
        Upload Files
      </Button>
    </div>
  )
}
